export default "__VITE_PUBLIC_ASSET__a4b5b4b7__"